import React from 'react';
import { CalendarIcon, CheckIcon } from 'lucide-react';
import { periodStatusLabels } from '../data/commissions';
import { Period } from '../types/commission';
import { HeaderDropdown } from './HeaderDropdown';
interface PeriodPickerProps {
  periods: Period[];
  selectedPeriodId: string;
  onSelect: (periodId: string) => void;
}
export function PeriodPicker({
  periods,
  selectedPeriodId,
  onSelect
}: PeriodPickerProps) {
  const selected = periods.find(period => period.id === selectedPeriodId) ?? periods[0];
  return <HeaderDropdown icon={<CalendarIcon className="h-4 w-4 shrink-0 text-slate-500" aria-hidden="true" data-id="element-404" data-mp="3i0ewq2iyqhw" />} label={selected.label} menuLabel="Select commission period" triggerClassName="w-48" menuClassName="w-64" data-id="element-403" data-mp="3gp8eihp34n3">
      {close => periods.map(period => {
      const isSelected = period.id === selectedPeriodId;
      return <button key={period.id} type="button" role="option" aria-selected={isSelected} onClick={() => {
        onSelect(period.id);
        close();
      }} className="flex w-full items-center justify-between gap-3 px-3.5 py-2 text-left text-sm transition hover:bg-slate-50" data-id="element-405" data-mp="3gtsdybvi6prg">
              <span className={isSelected ? 'font-semibold text-brand-800' : 'text-slate-700'} data-id="element-406" data-mp="3b3zz5joajf0d">{period.label}</span>
              <span className="flex items-center gap-2" data-id="element-407" data-mp="2ndnk7oumoi0a">
                <PeriodStatusChip status={period.status} data-id="element-408" data-mp="2jc26606cxxoi" />
                {isSelected ? <CheckIcon className="h-4 w-4 text-brand-700" aria-hidden="true" data-id="element-409" data-mp="2x2x8suq9jijn" /> : null}
              </span>
            </button>;
    })}
    </HeaderDropdown>;
}
export function PeriodStatusChip({
  status
}: {
  status: Period['status'];
}) {
  return <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${status === 'open' ? 'bg-emerald-50 text-emerald-700' : status === 'closed' ? 'bg-amber-50 text-amber-700' : 'bg-slate-100 text-slate-500'}`} data-id="element-410" data-mp="24ktelliwa28q">
      {periodStatusLabels[status]}
    </span>;
}